// Constantes de la integración OSRM routing.
// Referencias en: data/osrm-service.js, layers/route-renderer.js, views/MapV2.vue

// ─── IDs MapLibre ────────────────────────────────────────────
export const OSRM_PREVIEW_SOURCE = 'osrm-preview-source'
export const OSRM_ACTIVE_SOURCE = 'osrm-active-source'
export const OSRM_PREVIEW_LAYER = 'osrm-preview-line'
export const OSRM_ACTIVE_LINE_OUTLINE = 'osrm-active-line-outline'
export const OSRM_ACTIVE_LINE = 'osrm-active-line'
export const OSRM_ACTIVE_TARGET = 'osrm-active-target'

// ─── Umbrales ────────────────────────────────────────────────
// Re-ruteo: si la unidad activa se aleja >100m del origen de la última
// ruta, se pide una nueva. 100m equivale aprox a 5-12 segundos de
// movimiento típico (30-60 km/h) → la línea se reacomoda visualmente
// suave en lugar de quedar pegada al origen viejo hasta 30+ segundos
// (que es lo que pasaba con el threshold previo de 300m).
export const REROUTE_THRESHOLD_M = 100

// Intervalo del watcher que revisa el umbral. 500ms es 30x más lento
// que cualquier movimiento relevante; zero riesgo de miss.
export const REROUTE_CHECK_INTERVAL_MS = 500

// Debounce del hover sobre unidades en el drawer. Evita ráfaga de
// llamadas cuando el operador escanea el listado con el mouse.
export const HOVER_DEBOUNCE_MS = 150

// ─── Circuit breaker ────────────────────────────────────────
export const CIRCUIT_FAIL_THRESHOLD = 3
export const CIRCUIT_WINDOW_MS = 30000
export const CIRCUIT_OPEN_MS = 60000

// Timeout por llamada individual a OSRM.
export const OSRM_REQUEST_TIMEOUT_MS = 1500
// Distancia máxima (m) a la que OSRM puede "pegar" un punto a la red vial.
// Sin este límite, un punto fuera del grafo se pega a la calle más cercana
// aunque esté a 120 km y OSRM responde `Ok` con una ruta falsa (0/0 si ambos
// puntos caen fuera; una ruta plausible desde un origen equivocado si solo
// uno). Con el límite responde `NoSegment` y el caller degrada a línea recta.
export const OSRM_SNAP_RADIUS_M = 500

// ─── Helper: lee CSS var del token del tema en tiempo de ejecución ──────────
function readVar(name) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue('--kln-' + name).trim()
}

// ─── Estilos de línea (decisión D del spec) ─────────────────
// Funciones para leer los tokens del tema en el momento de uso.
// Width también por tema (route-active-width / route-preview-width)
// para el look tactical más grueso.
export const PREVIEW_COLOR        = () => readVar('alert-warning') || '#FFB400'
export const ACTIVE_COLOR         = () => readVar('entity-orange') || '#FF5722'
export const ACTIVE_OUTLINE_COLOR = '#FFFFFF'                        // blanco puro siempre

export const PREVIEW_WIDTH = () => parseFloat(readVar('route-preview-width')) || 2.5
export const ACTIVE_WIDTH  = () => parseFloat(readVar('route-active-width'))  || 4
// Outline escala con la active line — 1.5x el ancho, mínimo 6 px.
export const ACTIVE_OUTLINE_WIDTH = () => Math.max(6, ACTIVE_WIDTH() * 1.5)

// ─── Endpoint base ──────────────────────────────────────────
// Va vía nginx reverse proxy (location /osrm/) o vite dev proxy.
// Nunca se usa URL absoluta — debe quedar en same-origin.
export const OSRM_BASE_URL = '/osrm'
